<div class="container">
	@if (data.label) {
		<div class="heading">{{ data.label }}</div>
	}
	@if (data.showSearchInput) {
		<div class="search-box">
			<app-icon class="search-icon" name="search" color="primary-2"></app-icon>
			<input #inp type="text" (input)="search(inp.value)" [value]="searchInput()" placeholder="Zoeken..." />
		</div>
	}
	<div class="opties">
		@for (optie of data.opties(); track optie) {
			<div class="optie" [class.is-selected]="isSelected(optie)" (click)="clickOptie(optie)">
				<span class="optie-text text-content {{ optie.style }}" [title]="optie.text">{{ optie.text }}</span>
			</div>
		} @empty {
			<div class="optie no-options">
				<span class="optie-text">{{ data.showEmpty }}</span>
			</div>
		}
	</div>
</div>
